import { GridAlignment } from "@mui/x-data-grid";

import IconEyeOff from "../../../../../assets/images/icons/icon_eye_off.svg";
import IconEyeOn from "../../../../../assets/images/icons/icon_eye_on.svg";
import { DocumentFilter } from "../../../../../utils/types/documents.type";
import { DataGridColDef } from "../../../../../utils/types/listItems";
import DateUploadedCellRenderer from "../cells/DateUploadedCellRenderer";
import FileSizeCellRenderer from "../cells/FileSizeCellRenderer";
import FileStatusCellRenderer from "../cells/FileStatusCellRenderer";
import FundCellRenderer from "../cells/FundCellRenderer";
import InvestorCellRenderer from "../cells/InvestorCellRenderer";
import NameCellRenderer from "../cells/NameCellRenderer";
import QuarterCellRenderer from "../cells/PeriodCellRenderer";
import WaterMarkCellRenderer from "../cells/WaterMarkCellRenderer";

export const FundColDef: DataGridColDef = {
  field: "fund",
  headerName: "Fund",
  hide: false,
  index: 3,
  sortable: true,
  type: "chips",
  align: "left" as GridAlignment,
  width: 300,
  chipLabelField: "name",
  chipIDField: "id",
  chipCount: 3,
  renderChipForFilesOnly: true,
  renderChipForMultiItemsOnly: true,
  inlineFilter: true,
  inlineFilterName: DocumentFilter.Fund,
  inlineFilterIDField: "id",
  inlineFilterLabelField: "name",
  scrollContainerStyle: { maxWidth: "initial" },
  renderCell: FundCellRenderer,
};

export const FileSizeColDef: DataGridColDef = {
  field: "sizeInBytes",
  headerName: "File Size",
  hide: false,
  index: 5,
  sortable: false,
  type: "number",
  align: "left" as GridAlignment,
  width: 150,
  minWidth: 150,
  renderCell: FileSizeCellRenderer,
};

export const FileStatusColDef: DataGridColDef = {
  field: "status",
  headerName: "Status",
  hide: false,
  index: 6,
  sortable: false,
  type: "boolean",
  align: "left" as GridAlignment,
  width: 200,
  renderCell: FileStatusCellRenderer,
};

export const InvestorColDef: DataGridColDef = {
  field: "investor",
  headerName: "Investor",
  hide: false,
  index: 2,
  sortable: true,
  type: "string",
  align: "left" as GridAlignment,
  width: 300,
  minWidth: 300,
  renderCell: InvestorCellRenderer,
  inlineFilter: true,
  inlineFilterName: DocumentFilter.Investor,
  inlineFilterIDField: "id",
  inlineFilterLabelField: "name",
  scrollContainerStyle: { maxWidth: "initial" },
};

export const NameColDef: DataGridColDef = {
  flex: 0,
  field: "name",
  headerName: "Name",
  hide: false,
  index: 1,
  sortable: true,
  type: "string",
  align: "left" as GridAlignment,
  width: 400,
  minWidth: 300,
  renderCell: NameCellRenderer,
  inlineFilter: true,
  inlineFilterName: DocumentFilter.Name,
  inlineFilterIDField: "id",
  inlineFilterLabelField: "name",
};

export const FolderNameColDef: DataGridColDef = {
  field: "name",
  headerName: "Name",
  hide: false,
  index: 1,
  sortable: true,
  type: "string",
  align: "left" as GridAlignment,
  width: 500,
  renderCell: NameCellRenderer,
};

export const PermissionsColDef: DataGridColDef = {
  field: "permissions",
  headerName: "Permissions",
  hide: false,
  index: 2,
  sortable: false,
  type: "chips",
  align: "left" as GridAlignment,
  width: 600,
  chipLabelField: "name",
  chipIDField: "key",
  chipCount: 3,
  onChipClick: () => { },
  toggleVisibilityOnClick: true,
  inlineFilter: true,
  inlineFilterName: DocumentFilter.Permission,
  inlineFilterIDField: "key",
  inlineFilterLabelField: "name",
};

export const QuarterColDef: DataGridColDef = {
  field: "quarter",
  headerName: "Period",
  hide: false,
  index: 4,
  sortable: true,
  type: "string",
  align: "left" as GridAlignment,
  width: 300,
  renderCell: QuarterCellRenderer,
  inlineFilter: true,
  inlineFilterName: DocumentFilter.Quarter,
  inlineFilterIDField: "name",
  inlineFilterLabelField: "name",
  scrollContainerStyle: { maxWidth: "initial" },
};

export const WaterMarkColDef: DataGridColDef = {
  field: "hasWatermark",
  headerName: "Watermark",
  hide: false,
  index: 3,
  sortable: true,
  type: "boolean",
  align: "left" as GridAlignment,
  width: 200,
  renderCell: WaterMarkCellRenderer,
};

export const DateUploadedColDef: DataGridColDef = {
  field: "uploaded",
  headerName: "Date Uploaded",
  hide: false,
  index: 5,
  sortable: false,
  type: "string",
  align: "left" as GridAlignment,
  width: 200,
  renderCell: DateUploadedCellRenderer,
};
